import { Component, Input, OnInit, DoCheck, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute } from '@angular/router';

//Service File
import { SolutionFormService } from '../solutionForm/solutionForm.service';
//Query File
import { ReportReviewQueryService, SolutionMasterQueryService } from '../../queryFiles/index';
//Toast component
import { ToastComponent } from '../../common/toast.component';
//Edit Component
import { EditFormDialogComponent } from '../solutionForm/spekwo-type/edit-model/editForm.component';
//Common File
import { itemsPerPage, paginationForCustomTable, spekwoType, toastMsg, toolTip } from '../../utils/index';
//Dialog File
import { FuseConfirmDialogComponent } from '../../../../../core/components/confirm-dialog/confirm-dialog.component';
import { ConfirmDialogComponent } from '../solutionForm/confirm-dialog/confirm-dialog.component';
import { AuditHistoryService } from '../../../../../core/services/audit-history.service';

@Component({
  selector: 'app-common-table',
  templateUrl: './common-table.component.html',
  styleUrls: ['./common-table.component.scss']
})
export class CommonTableComponent implements OnInit {

  @Input() pageType: string;
  @Input() tableValues: any;
  @Input() total: number;
  @Input() tableValuesForDrag: any;
  @Input() cancelWorkRequest: boolean;
  @Input() enableAction: any;

  @Input() isAllowed: boolean;
  @Input() viewBoolean: boolean=false;
  currentOrderId: number;

  // const file
  spekwoType = spekwoType;
  toolTip = toolTip;


  //total cost


  //Edit
  dialogRef: any;
  combineCategories: any[] = [];
  toastMsg = toastMsg;
  confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
  emailConfirmRef: MatDialogRef<ConfirmDialogComponent>;
  private _subscriptions: Subscription[] = [];

  // pagination
  initalLoad = itemsPerPage; //Initial data load per page
  initalLoadForReports = itemsPerPage; //Initial data load per page
  pageForReports: number = 1;
  itemsPerPageForReports: number;//Items per page in paginator
  pageNumberForReports: number;
  pageNumber: number;// for which page we are currently in
  itemsPerPage: number;//Items per page in paginator
  paginationForReports = paginationForCustomTable;

  @Output() public onValueChanged: EventEmitter<number> = new EventEmitter();
  //Drag
  showDragSave: boolean = false;
  selectedId: string = ''; //To find drag index to highlight row(review reports)
  dragIndexForReports: number;
  dragIndex: number; // for identifying dragIndex based on paginator value

  doCheckFlag: boolean = false;
  isActionEnabled: boolean;
  roleId: any;
  userId: any;

  constructor(
    public route: ActivatedRoute,
    public dialog: MatDialog,
    /** Local component */
    private toastComponent: ToastComponent,
    /** Query file */
    public solutionMasterQueryService: SolutionMasterQueryService,
    public reportReviewQueryService: ReportReviewQueryService,
    private solutionFormService: SolutionFormService,
    public auditHistoryService: AuditHistoryService,
  ) {
    this.isActionEnabled = false;
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  ngOnInit() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });

    this.roleId = window.localStorage.getItem("roleId");
    this.userId = window.localStorage.getItem('userUID');

    this.pageNumber = 1;// initially set to 1st page
    this.itemsPerPage = this.initalLoad; // initally set to initial value
    this.dragIndex = 0; //initially set to 0

    this.itemsPerPageForReports = this.initalLoadForReports;
    this.pageNumberForReports = 1;
    this.dragIndexForReports = 0;

    // get current order from params
    this.route.params.subscribe(params => {
      this.currentOrderId = params.id;
    });

  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.tableValues) {
      this.tableValues = changes.tableValues.currentValue;
    }
    if (changes.enableAction) {
      this.enableAction = changes.enableAction.currentValue;
      this.isActionEnabled = false;
    }
  }
  editCategory(row) {
    this.dialogRef = this.dialog.open(EditFormDialogComponent, {
      width: '120%',
      panelClass: 'edit-form-dialog',
      data: {
        category: row,
        allCategory: this.combineCategories,
        action: 'edit',
        orderId: this.currentOrderId
      }
    });

    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }
        const actionType: string = response[0];
        const formData: FormGroup = response[1];
        switch (actionType) {
          /**
           * Save
           */
          case 'save':

            const status: string = response[2];
            const mainCategory: FormGroup = response[3];
            const solSubCategory: FormGroup = response[4];

            if (status == 'success') {

              this.toastComponent.showToast(this.toastMsg.updateSuccess);
              console.log("before edit", this.tableValues);
              console.log("formData after edit ", formData.getRawValue());

              const matchIndex = this.tableValues.indexOf(row);
              this.tableValues[matchIndex].costOption = formData.getRawValue().costOption;
              this.tableValues[matchIndex].description = formData.getRawValue().description;
              this.tableValues[matchIndex].id = formData.getRawValue().id;
              this.tableValues[matchIndex].name = formData.getRawValue().categoryName;
              this.tableValues[matchIndex].reviewId = formData.getRawValue().reviewId;
              this.tableValues[matchIndex].solution = formData.getRawValue().solution;
              this.tableValues[matchIndex].totalCost = formData.getRawValue().totalCost;
              this.tableValues[matchIndex].categoryName = formData.getRawValue().categoryName;
              this.tableValues[matchIndex].subCategoryName = mainCategory;
              this.tableValues[matchIndex].cpi = formData.getRawValue().cpi;
              this.tableValues[matchIndex].ni = formData.getRawValue().ni;
              this.tableValues[matchIndex].hourRate = formData.getRawValue().hourRate;
              this.tableValues[matchIndex].laborHour = formData.getRawValue().laborHour;
              this.tableValues[matchIndex].labourCost = formData.getRawValue().labourCost;
              this.tableValues[matchIndex].materialCost = formData.getRawValue().materialCost;
              this.tableValues[matchIndex].cpf = formData.getRawValue().cpf;
              this.tableValues[matchIndex].tf = formData.getRawValue().tf;
              this.doCheckFlag = true;
              this.updateTotal(this.tableValues);
            } else {
              this.toastComponent.showToast(this.toastMsg.updateFailed);
            }

            break;
          /**
           * Delete
           */
          case 'delete':
            this.deleteCategory(row);
            break;
        }
      });
  }

  //Remove a row from solution report
  deleteCategory(category) {


    // if (this.cancelWorkRequest) {
    //   this.deleteClientToggleSolution(category);
    // }

    // this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
    //   disableClose: false
    // });

    // this.confirmDialogRef.componentInstance.confirmMessage = this.toastMsg.deleteCategoryConfirm;
    // this.confirmDialogRef.componentInstance.confirmHead = this.toastMsg.deleteCategoryHead;
    // this.confirmDialogRef.componentInstance.confirmOkText = this.toastMsg.deleteCategoryOk;
    // this.confirmDialogRef.componentInstance.confirmCancelText = this.toastMsg.deleteCategoryCancel;

    // this.confirmDialogRef.afterClosed().subscribe(result => {

    //   if (result) {

    //     if (this.pageType == 'workRequestPage') {
    //       this.deleteClientToggleSolution(category);
    //       this.toastComponent.showToast(this.toastMsg.deleteCategory);
    //       const contactIndex = this.tableValues.indexOf(category);
    //       this.tableValues.splice(contactIndex, 1);
    //       this.updateTotal(this.tableValues);
    //     }
    //     else if (this.pageType == 'solutionEstimatePage') {
    //       this._subscriptions.push(
    //         this.reportReviewQueryService.DELETE_REPORT_REVIEW(category)
    //           .subscribe((response: any) => {
    //             this.toastComponent.showToast(this.toastMsg.deleteCategory);
    //             const contactIndex = this.tableValues.indexOf(category);
    //             this.tableValues.splice(contactIndex, 1);
    //             this.updateTotal(this.tableValues);
    //           }));
    //     }
    //   }
    //   this.confirmDialogRef = null;
    // });
    if (this.cancelWorkRequest) {
      this.deleteClientToggleSolution(category);
    }

    this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
      disableClose: false
    });

    this.confirmDialogRef.componentInstance.confirmMessage = this.toastMsg.deleteCategoryConfirm;
    this.confirmDialogRef.componentInstance.confirmHead = this.toastMsg.deleteCategoryHead;
    this.confirmDialogRef.componentInstance.confirmOkText = this.toastMsg.deleteCategoryOk;
    this.confirmDialogRef.componentInstance.confirmCancelText = this.toastMsg.deleteCategoryCancel;

    this.confirmDialogRef.afterClosed().subscribe(result => {

      if (result) {

        if (this.pageType == 'workRequestPage') {
          this.deleteClientToggleSolution(category);
          this.toastComponent.showToast(this.toastMsg.deleteCategory);
          const contactIndex = this.tableValues.indexOf(category);
          this.tableValues.splice(contactIndex, 1);
          this.updateTotal(this.tableValues);

          // Audit History Delete Call
          let savedDetails = {
            description: category.description,
            totalCost: category.totalCost,
            solution: category.solution,
            categoryName: category.categoryName,
          };

          this.auditHistoryDeleteFunCall(savedDetails, "Success");


        }
        else if (this.pageType == 'solutionEstimatePage') {
          this._subscriptions.push(
            this.reportReviewQueryService.DELETE_REPORT_REVIEW(category)
              .subscribe((response: any) => {
                this.toastComponent.showToast(this.toastMsg.deleteCategory);
                const contactIndex = this.tableValues.indexOf(category);
                this.tableValues.splice(contactIndex, 1);
                this.updateTotal(this.tableValues);

                // Audit History Delete Call
                let savedDetails = {
                  description: category.description ? category.description : '',
                  totalCost: category.totalCost = "0.00" ? '' : category.totalCost,
                  solution: category.solution ? category.solution : '',
                  categoryName: category.categoryName ? category.categoryName : '',
                };

                this.auditHistoryDeleteFunCall(savedDetails, "Success");


              }, (error) => {

                console.log("Delete solution getting failed", error)
                // Audit History Delete Call
                let savedDetails = {
                  description: category.description ? category.description : '',
                  totalCost: category.totalCost = "0.00" ? '' : category.totalCost,
                  solution: category.solution ? category.solution : '',
                  // insReportId: category.insReportId,
                  categoryName: category.categoryName ? category.categoryName : '',
                  // costOption: category.costOption,
                };

                this.auditHistoryDeleteFunCall(savedDetails, "failed");
              }));
        }
      }
      this.confirmDialogRef = null;
    });

  }
  deleteClientToggleSolution(category) {
    this.solutionFormService.getAcceptedClientOrders(this.currentOrderId).then((response: any) => {
      let checOrderFound = response.data.allReportSolutionMasters.edges.filter(data => {
        return category.id === data.node.reportReviewDetailByReviewId.id
      });

      if (checOrderFound && checOrderFound.length > 0) {
        let id = checOrderFound[0].node;
        this._subscriptions.push(
          this.solutionMasterQueryService.DELETE_CLIENT_REPORT_REVIEW(id).subscribe((response: any) => {

          }));

      }
    }).catch((err) => {
      console.log(err);
    })
  }

  //after edit or delete solution update the total
  updateTotal(tableValues) {
    var updatedTotal = tableValues.reduce((acc, curr) => {
      return acc = Number(acc) + Number(curr.totalCost);
    }, 0);
    this.total = updatedTotal;
    if (this.pageType == 'solutionEstimatePage') {
      this.onValueChanged.emit(this.total);
    }
  }

  // Drag

  drag(event, id) { //dragstart -Review reoprts
    this.showDragSave = true;
    this.selectedId = id;
  }

  //After drop success calling save function
  transferDataSuccess(dragIndexForReports, $event) {
    this.save();
    this.selectedId = '';
  }

  save() {

    this.showDragSave = false;
    var temp1 = [];

    this.tableValues.forEach((data, key) => {
      var temp = {
        categoryName: data.categoryName,
        description: data.description,
        categoryId: data.categoryId,
        totalCost: data.totalCost,
        solution: data.solution,
        approve: 'no', //bec it is alter state..so we passed 'no' here
        name: data.subCategoryName ?
          data.categoryName ?
            data.categoryName + ':' + data.subCategoryName
            : data.subCategoryName
          : data.categoryName,
        reviewId: this.tableValuesForDrag[key].reviewId,
        id: this.tableValuesForDrag[key].id,
        insReportId: data.insReportId,
        hourRate: Number.parseFloat(data.hourRate),
        laborHour: Number.parseInt(data.laborHour),
        labourCost: Number.parseFloat(data.labourCost),
        materialCost: Number.parseFloat(data.materialCost),
        ni: Number.parseInt(data.ni),
        cpi: Number.parseFloat(data.cpi),
        cpf: Number.parseFloat(data.cpf),
        tf: Number.parseInt(data.tf),
        reviewNodeId: this.tableValuesForDrag[key].reviewNodeId,
        costOption: data.costOption,
      }
      temp1.push(temp);
      if (key + 1 == this.tableValuesForDrag.length) {
        this.tableValues = temp1;
        this.saveDragSolution(this.tableValues);
      }
    });
  }

  saveDragSolution(tableValues) {

    tableValues.forEach((report, key) => {

      // Change approve status
      this._subscriptions.push(
        this.reportReviewQueryService.UPDATE_REPORT_REVIEW_AFTER_DRAGGING(report.reviewNodeId, report)
          .subscribe((response: any) => {
            if (key + 1 == tableValues.length) {
              this.toastComponent.showToast(this.toastMsg.afterReview);
            }
          }, (err) => {
            this.toastComponent.showToast(this.toastMsg.failedReview);
            console.log('err', err);
          }));
    });

  }

  // pagination

  // set current paginator value -Review reoprts//
  getPaginatorForReports(key) {
    this.itemsPerPageForReports = key;
    this.dragIndexChangeForReports();
  }

  //set current page -Review reoprts //
  getPageForReports($event) {
    this.pageNumberForReports = $event;
    this.dragIndexChangeForReports();
  }


  // for identifying dragIndex based on paginator value -Review reoprts
  dragIndexChangeForReports() {
    this.dragIndexForReports = (Number(this.itemsPerPageForReports) * (Number(this.pageNumberForReports) - 1))
  }
  action() {
    this.isActionEnabled = true;
  }

  auditHistoryDeleteFunCall(savedDetails, status) {

    let auditLogPayload = {
      roleId: this.roleId,
      userId: this.userId,
      orderId: Number(this.currentOrderId),
      newData: savedDetails,
      oldData: null,
      auditType: "solution_estimate_delete",
      logsDesc: "Solution Estimate Deleted",
      platform: "Executive Dashboard",
      status: status
    };

    this.auditHistoryService.auditHistoryForCreateOrDeleteCall(auditLogPayload);
  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/common-table/common-table.component.ts